import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import { getCreatableEnvironments } from "../helpers/mappingHelper";

const GeneralSettings = ({ onGeneralSettingsChanged, errors }) => {
  const [environment, setEnvironment] = useState(
    "nulogy-pm-production/packmanager-training",
  );
  const [companyName, setCompanyName] = useState("");
  const [demoDate, setDemoDate] = useState("");

  const updateEnvironment = (evt) => {
    setEnvironment(evt.target.value);
  };

  const updateCompanyName = (evt) => {
    setCompanyName(evt.target.value);
  };

  const updateDemoDate = (evt) => {
    setDemoDate(evt.target.value);
  };

  useEffect(() => {
    onGeneralSettingsChanged({
      environment,
      companyName,
      demoDate,
    });
  }, [environment, companyName, demoDate, onGeneralSettingsChanged]);

  return (
    <div className="card" style={{ marginBottom: "24px" }}>
      <div className="card-body">
        <h3 className="card-title">1. Enter General Settings</h3>
        <div className="card-text">
          <div className="form-group">
            <div className="col-xs-3">
              <label htmlFor="environment-select">
                Environment<span className="text-danger">*</span>
              </label>
              <select
                data-testid="environment-select"
                className="form-control"
                id="environment-select"
                value={environment}
                onChange={updateEnvironment}
              >
                {getCreatableEnvironments().map((environment) => {
                  return (
                    <option
                      key={environment.environment}
                      value={environment.environment}
                    >
                      {environment.name}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>

          <div className="form-group">
            <div className="col-xs-3">
              <label htmlFor="company-name">
                Demo Company Name<span className="text-danger">*</span>
              </label>
              <input
                type="text"
                id="company-name"
                className="form-control"
                placeholder="e.g. Acme Co"
                onChange={updateCompanyName}
                value={companyName}
                data-testid="company-name"
                required
              />
              <span id="company-name-errors" className="text-danger">
                {errors.companyName}
              </span>
            </div>
          </div>

          <div className="form-group">
            <div className="col-xs-3">
              <label htmlFor="demo-date" id="demo-date-label">
                Demo Date
              </label>
              <input
                type="datetime-local"
                id="demo-date"
                className="form-control"
                onChange={updateDemoDate}
                value={demoDate}
                data-testid="demo-date"
              />
              <span id="demo-date-errors" className="text-danger">
                {errors.demoDate}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

GeneralSettings.propTypes = {
  onGeneralSettingsChanged: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
};

export default GeneralSettings;
